var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"captcha_class"},[(_vm.type == 'popup')?_c('div',{staticClass:"captchaTitle"},[_vm._v("请完成安全验证")]):_vm._e(),_c('div',{attrs:{"id":"captcha-element"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }